import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  AddVehicleBrand,
  EditVehicleBrand,
  GetVehicleBrand,
  Upload,
} from "../../fetchs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class VehicleBrand extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      name: "",
      nameHelper: "",
      imageAddress: "",
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    const vehicleBrandId = this.props.match.params.vehicleBrandId;
    if (vehicleBrandId) {
      this.loadVehicleBrand(vehicleBrandId);
    }
  }

  loadVehicleBrand = (vehicleBrandId) => {
    this.setState({ loading: true });
    GetVehicleBrand(vehicleBrandId)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            id: responseJson.id,
            name: responseJson.name,
            imageAddress: responseJson.imageAddress,
          });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  handleSave = () => {
    if (this.props.match.params.vehicleBrandId) this.editVehicleBrand();
    else this.addVehicleBrand();
  };

  addVehicleBrand = () => {
    AddVehicleBrand({
      name: this.state.name,
      imageAddress: this.state.imageAddress,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای اضافه شدن برند ماشین");
        } else if (response.status === 200) {
          toast.success(" برند ماشین با موفقیت اضافه شد");
          this.props.history.push("/main/vehiclebrands");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  editVehicleBrand = () => {
    EditVehicleBrand({
      id: this.props.match.params.vehicleBrandId,
      name: this.state.name,
      imageAddress: this.state.imageAddress,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای ویرایش شدن برند ماشین");
        } else if (response.status === 200) {
          toast.success(" برند ماشین با موفقیت ویرایش شد");
          this.props.history.push("/main/vehiclebrands");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSelectFile = (event) => {
    Upload(event.target.files[0], "goods")
      .then((response) => {
        return response.text();
      })

      .then((responseJson) => {
        this.setState({ imageAddress: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "name":
        this.setState({ name: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ nameHelper: "لطفا نام برند ماشین  را وارد کنید" });
        } else {
          this.setState({ nameHelper: "" });
        }
        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.vehicleBrandId ? (
              <Typography component="h1" variant="h4" align="center">
                ویرایش برند ماشین
              </Typography>
            ) : (
              <Typography component="h1" variant="h4" align="center">
                افزودن برند ماشین جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      error={this.state.nameHelper.length !== 0}
                      helperText={this.state.nameHelper}
                      onChange={this.onchange}
                      id="name"
                      label="نام"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.name}
                      margin="normal"
                      InputLabelProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <div>
                      <input
                        accept="image/*"
                        className={classes.input}
                        style={{ display: "none" }}
                        id="raised-button-file"
                        multiple
                        type="file"
                        onChange={this.handleSelectFile}
                      />
                      <label htmlFor="raised-button-file">
                        <Button
                          fullWidth
                          variant="contained"
                          component="span"
                          className={classes.button}
                        >
                          ارسال عکس
                        </Button>
                        {this.state.uploadPic && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </label>
                    </div>
                    <div>
                      <div className="picParent">
                        <img
                          src={`http://test.asa-oil.ir/${this.state.imageAddress}`}
                          className="picture"
                          alt={this.state.name}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={this.state.loading}
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

VehicleBrand.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(VehicleBrand));
